import { Injectable, EventEmitter } from '@angular/core';
import { Servidor } from '../modelos/servidor';

const token = 'token';
const dados_pessoais = 'dados_pessoais';
const usuario = 'usuario';

@Injectable({
  providedIn: 'root'
})
export class StorageLocalService {

  emitirEscolha = new EventEmitter<string>();
  emitirServidor = new EventEmitter<Servidor>();

  constructor() { }

  getToken(): any {
    return localStorage.getItem(token);
  }

  setToken(token_acesso) {
    if (token_acesso) {
      localStorage.setItem(token, JSON.stringify(token_acesso));
    }
  }

  getServidor(): any {
    return localStorage.getItem(dados_pessoais);
  }

  setServidor(dados_servidor) {
    if (dados_servidor) {
      localStorage.setItem(dados_pessoais, JSON.stringify(dados_servidor));
    }
  }

  getUsuario(): any {
    return localStorage.getItem(usuario);
  }

  setUsuario(usuario_logado) {
    if (usuario_logado) {
      localStorage.setItem(usuario, JSON.stringify(usuario_logado));
    }
  }

  limparToken() {
    localStorage.clear();
  }
}
